import Transfer from "./Transfer";

const routes = [
    {
        path: 'transactions/transfer',
        element: <Transfer />
    },
]
export default routes;